import { Box, CircularProgress, Pagination, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import personApi from '~/apis/person';
import dayjs from 'dayjs';

type MessageItem = {
  id: number;
  cccd: string;
  imei: string;
  message: string;
  send_status: number;
  error_message?: string | null;
  sent_by: string;
  created_date: string;
};

type Props = {
  personId: string | number;
};

const PersonMessages = ({ personId }: Props) => {
  const { t } = useTranslation('admin/person');
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<MessageItem[]>([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize] = useState(5);
  const [total, setTotal] = useState(0);

  const fetch = async (page = 1) => {
    try {
      setLoading(true);
      const res = await personApi.getMessages(personId, page, pageSize);
      const data = res.data?.result;
      setItems(data?.items || []);
      setTotal(data?.total || 0);
      setPageIndex(data?.page_index ? Number(data.page_index) : page);
    } catch (e) {
      setItems([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!personId) return;
    fetch(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personId]);

  return (
     <Box className="flex flex-col h-full">
  <Box className="flex-1 overflow-auto">
      <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>{t('message.columns.time')}</TableCell>
          <TableCell>{t('message.columns.from')}</TableCell>
          <TableCell>{t('message.columns.message')}</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {items.map((it) => (
          <TableRow key={it.id}>
            <TableCell>
              {it.created_date
                ? dayjs(it.created_date).format('DD/MM/YYYY HH:mm:ss')
                : ''}
            </TableCell>

            <TableCell>{it.sent_by}</TableCell>

            <TableCell
              sx={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {it.message}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>

  {/* Pagination luôn nằm dưới */}
  <Box className="flex justify-end py-3 bg-white border-t">
    <Pagination
      count={Math.ceil((total || 0) / pageSize)}
      page={pageIndex}
      onChange={(_, p) => fetch(p)}
      color="primary"
    />
  </Box>
</Box>
  );
};

export default PersonMessages;
